import { SalesOrderDepositReportLine } from './sales-order-deposit-report-line';
import { SellingCompanyReport } from '../../../../tms-shared';

export interface SalesOrderDepositReport {
  id: string;
  orderNo: number;
  customerKey: string;
  customerName: string;
  customerOrderNo: string;
  customerOrderRef: string;
  customerConfirmationEmailAddress: string;
  currency: string;
  currencySymbol: string;
  dateOrdered?: Date;
  enteredBy: string;
  customerAddress: string;
  deliveryAddress: string;
  paymentTerms: string;
  deliveryTerms: string;
  modeOfTransport: string;
  shipper: string;
  depositValue: number;
  taxValue: number;
  taxRate: number;
  overallValue: number;
  notes: string;
  bankName: string;
  bankIBAN: string;
  bankSwift: string;
  bankAccount: string;
  bankAccountName: string;
  bankSortCode: string;
  documentNotes: string;
  deliveryInstructions: string;
  deliveryTermNotes: string;
  shippingNotes: string;
  agentName: string;
  deliveryAddressee: string;
  printDeliveryAddress: boolean;
  sellingCompany: SellingCompanyReport;
  salesOrderDeposits: SalesOrderDepositReportLine[];
  orderedBy: string;
}
